import { useAuthStore } from "../../stores/authStore";
import { GRCManagerDashboard } from "./GRCManagerDashboard/GRCManagerDashboard";
import { CISODashboard } from "./CISODashboard";
import { GroupAuditorDashboard } from "./GroupAuditorDashboard/GroupAuditorDashboard";
import { SystemOwnerDashboard } from "./SystemOwnerDashboard/SystemOwnerDashboard";

/* ============================================================================
   DashboardRouter — the single "Dashboard" landing page.

   Every role gets the same dashboard-configuration-driven dashboard (it shows
   only the cards enabled for the role in Dashboard Config and resolves its own
   org/group scope internally). The header title reflects the logged-in role,
   e.g. "Administrator Dashboard" / "ISSO Dashboard".

   CISO keeps its dedicated dashboard for now.
   ========================================================================== */

/* role string compare that ignores case / spaces / underscores / hyphens. */
const norm = (s: string) => s.toLowerCase().replace(/[\s_-]/g, "");

export function DashboardRouter({ hideTitle = false }: { hideTitle?: boolean } = {}) {
  const roles = useAuthStore((s) => s.user?.roles) ?? [];
  const has = (...names: string[]) => roles.some((r) => names.includes(norm(r)));

  if (has("ciso")) return <CISODashboard hideTitle={hideTitle} />;
  if (has("auditor")) return <GroupAuditorDashboard hideTitle={hideTitle} />;
  // Application Manager persona maps to the existing system_owner role
  // (no separate role exists for it) — was previously a tab inside the
  // Auditor's Group Auditor Dashboard, moved to its own persona page since
  // an Auditor should not see it and a System Owner should see it by default.
  if (has("systemowner")) return <SystemOwnerDashboard />;
  return <GRCManagerDashboard hideTitle={hideTitle} />;
}
